import e from "./index.ce.vue.js";
import { defineAndRegisterElement as i } from "../../utils/register-element.js";
const r = i(e);
export {
  r as initHouseTypeEditDialog
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/house-type-edit-dialog/index.js
// module id = 1259
// module chunks = 41